import React, {useCallback, useEffect, useState} from "react";
import {deleteSkillType, updateSkillType} from "../../../../service/adminService";
import {Button, ButtonToolbar, Form, Modal, Stack} from "rsuite";
import {adminSkillTypeModel} from "../../../form/models";

const EditSkillTypeModal = (props) => {
    const { open, handleClose, selectedSkillType } = props

    const [localState, setLocalState] = useState();

    useEffect(() => {
        setLocalState({...selectedSkillType});
    }, [selectedSkillType]);

    const submitSkillTypeEdit = (isFormValid) => {
        if(!isFormValid) return;
        updateSkillType(localState).then((response) => {
            handleClose(response);
        });
    };

    const submitSkillTypeDelete = useCallback(() => {
        deleteSkillType({id: localState.id}).then((response) => {
            handleClose(response);
        });
    }, [handleClose, localState]);

    // rsuite does not have an onSubmit, we must handle state changes per controlled field
    const handleFormChange = (event) => {
        setLocalState({...localState, ...event});
    }

    return (
        <Modal
            open={open}
            onClose={handleClose}
            backdrop="static"
        >
            <Modal.Header>
                <Modal.Title>Edit Skill Type</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Stack spacing={2} direction='column' alignItems='flex-start'>
                    <p>
                        Changes/removal will cascade to all skills under the skill type.
                    </p>
                    <p>
                        <b>Warning:</b> Deleting a skill type will remove ALL skills of this type for all users.
                    </p>
                </Stack>
            </Modal.Body>
            <Form
                layout="horizontal"
                model={adminSkillTypeModel}
                onChange={handleFormChange}
                onSubmit={submitSkillTypeEdit}
                formDefaultValue={selectedSkillType}
            >
                <Form.Group>
                    <Form.ControlLabel>Skill Type Name</Form.ControlLabel>
                    <Form.Control name="skillTypeName"/>
                </Form.Group>
                <Form.Group>
                    <ButtonToolbar>
                        <Button type="submit" appearance="primary">
                            Ok
                        </Button>
                        <Button onClick={handleClose} appearance="default">
                            Cancel
                        </Button>
                        <Button onClick={submitSkillTypeDelete} appearance="primary" color="red">
                            Delete Skill Type
                        </Button>
                    </ButtonToolbar>
                </Form.Group>
            </Form>
        </Modal>
    );
};


export default EditSkillTypeModal;